import { render, staticRenderFns } from "./TeacherIndividualAwayAssignmentModal.vue?vue&type=template&id=605e593b&scoped=true&"
import script from "./TeacherIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"
export * from "./TeacherIndividualAwayAssignmentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605e593b",
  null
  
)

export default component.exports